import React, { useEffect, useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Menu, Input, Form, Button, Modal, FormField, Dropdown, DropdownItem} from 'semantic-ui-react';
import config from '../../config/config';
import { openSearch, openAuth, closeSearch } from './actions';
import {isAuthVisible} from './reducer';
import './NavBar.css';
import { getUserDisplayName } from '../UserLogin/reducer';
import { isMobile } from 'react-device-detect';
import { SEARCH_CONTEXTS, setSearchContext } from "../../views/Search/actions";
import { getToContext } from "../../views/Search/reducer";
import { closeMenu } from "../NavBottomBar/actions";
import DropdownComponent from "../DropdownComponent";

import BookmarkIcon from '../../icons/bookmark-white-icon.png';
import BellIcon from '../../icons/bell-icon.png';
import EventsIcon  from '../../icons/events-icon.png';
import BellIconNotify from '../../icons/BellIconNotify.png'
import { ReactComponent as BackIcon } from '../../icons/back-icon.svg';
import { ReactComponent as SearchIcon } from '../../icons/search-icon.svg';
import { ReactComponent as FilterIcon } from '../../icons/filter-icon.svg';
import { ReactComponent as GlobalFilter } from '../../icons/global_filter.svg';
import { ReactComponent as CloseIconAsia} from "../../icons/close-red-icon.svg";
import { ReactComponent as CloseIconGras } from "../../icons/close-green-icon.svg";



import {getForums} from "../../views/CongressAE2024/BusinessProgram/reducer";
import {
    getCurrentSegment,
    getExponentFilter,
    getExponents, getFilterState,
    getPDFExponent,
    getSegments
} from "../../views/Exponents/reducer";
import Search from "../../views/Search";
import {useParams} from "react-router";
import Exponents from "../../views/Exponents";
import {getCountries} from "../AddressCard/reducer";
import {
    clearCountryFilter,
    clearSearch,
    clearSegmentFilter,
    fetchExponents,
    setCountryFilter, setFilterExpClose, setFilterExpOpen,
    setSearch,
    setSegmentFilter
} from "../../views/Exponents/action";
import {getLanguage, setLanguage} from "../LanguageModal/reducer";
import translations from "../LanguageModal/translations";
import LanguageIcon from "../../icons/language-icon.png";
import LanguageModal from "../LanguageModal/LanguageModal";
import {setPopupOpen} from "../../views/EditProfile/actions";
import {getOrders} from "../../views/Orders/reducer";
import {isArray} from "lodash";
import {getNotifications} from "../../views/Notifications/reducer";
import {kitcut} from "../WindowDimensions";
import {setTypeExhibition} from "../../views/Home/actions";
import {getTypeExhibition} from "../../views/Home/reducer";
import {setCloseFilter, setOpenFilter} from "../../views/AsiaMeet/actions";
import {getStateFilter} from "../../views/AsiaMeet/reducer";

export default function NavTopBar(props) {
    const { searchVisible, dispatch, navigate, userData, userLocation, mixpanel, isLoggedIn, location, isPageReloaded } = props;

    const typeExhibition = getTypeExhibition(useSelector((state) => state.exhibition));
    const isMeetsFilterOpen = useSelector((state) => getStateFilter(state.meets))
    const authVisible = useSelector((state) => isAuthVisible(state.navtopbar));
    const userNickName = useSelector((state) => getUserDisplayName(state.userLogin));
    const searchContext = useSelector((state) => getToContext(state.search));
    const forums = useSelector((state) => getForums(state.forums));
    const notifications = useSelector((state) => getNotifications(state.notifications));
    const exponents = useSelector((state) => getExponents(state.exponents));
    const isModalOpen = useSelector((state) => getFilterState(state.exponents));
    const segments = useSelector((state) => getSegments(state.exponents));
    const filterExponents = useSelector((state) => getExponentFilter(state.exponents));
    const segmentTopbar = useSelector((state) => getCurrentSegment(state.exponents));
    const pdf = useSelector((state) => getPDFExponent(state.exponents));
    const orders = useSelector((state)=>getOrders(state.orders))

    const countries = useSelector((state) => getCountries(state.address));

    const [isFilterDropdownOpen, setFilterDropdownOpen] = useState(false);
    const [isFilterDropdownOpenArchive, setFilterDropdownOpenArchive] = useState(false);
    const [searchState, setSearchState] = useState({ search: '', context: searchContext });
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [currentExponentName, setCurrentExponentName] = useState('');
    const [isSearchOpenArchive, setIsSearchOpenArchive] = useState(false)
    const isMainView = location.pathname === '/';
    const isTicketView = location.pathname.startsWith(`/checkout-step-confirm/`)
    const isProfileView = location.pathname === '/profile';
    const isBookmarksView = location.pathname === '/bookmarks';
    const isAsiameetView = location.pathname === '/asiameet';
    const isNotificationsView = location.pathname === '/notifications';
    const isExponentsView = location.pathname === '/exponents';
    const isAsiaMeetView = location.pathname === '/asiameet';
    const isExponentsArchiveView = location.pathname === '/archive-events/congress-asiaexpo-2023/exponents';
    const isScheduleView = location.pathname === '/schedule';
    const isSearchView = location.pathname.startsWith('/search/');
    const isFormChanged = useSelector((state) => state.formReducer.isFormChanged);

    const languageDispatch = useDispatch();
    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];

    const handleLanguageChange = (newLanguage)=>{
        languageDispatch(setLanguage(newLanguage))
    }

    const t = (key) => {
        const languageString = language[0]+language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };

    useEffect(() => {
        if (location.pathname === "/archive-events/congress-asiaexpo-2024/exponents" && filterExponents.country.length > 0 || filterExponents.segment.length > 0) {
            setFilterDropdownOpen(true);
        }
        if (location.pathname === "/archive-events/congress-asiaexpo-2023/exponents" && filterExponents.country.length > 0 || filterExponents.segment.length > 0) {
            setFilterDropdownOpenArchive(true);
        }
    }, []);

    useEffect(() => {
        if (location.pathname !== '/exponents') {
            dispatch(setFilterExpClose())
        }
    }, [location.pathname]);


    let mainText = 'Error';

    if (location.pathname === '/') {
        mainText = t('main');
    } else if (location.pathname.startsWith('/archive-events/congress-asiaexpo-2024/description-congress')) {
        mainText = t("descCongress");
    } else if (location.pathname.startsWith('/archive-events/congress-asiaexpo-2024/cultural-program')) {
        mainText = t("culturalProgram");
    } else if (location.pathname.startsWith('/description-congress')) {
        mainText = t("descCongress");
    } else if (location.pathname.startsWith('/cultural-program')) {
        mainText = t("culturalProgram");
    } else if (location.pathname.startsWith('/archive-events')) {
        mainText = t("archiveEvents");
    } else if (location.pathname.startsWith('/archive-events/congress-asiaexpo-2023')) {
        mainText = t("congress") + " " + t("ae2023");
    } else if (location.pathname.startsWith('/archive-events/congress-asiaexpo-2024')) {
        mainText = t("congress") + " " + t("ae2024");
    } else if (location.pathname.startsWith('/archive-events/congress-asiaexpo-2023/cultural-program')) {
        mainText = t("culturalProgram");
    } else if (location.pathname.startsWith('/archive-events/congress-asiaexpo-2023/business-program-archive')) {
        mainText = t("busProgram");
    } else if (location.pathname.startsWith('/archive-events/congress-asiaexpo-2023/exponents')) {
        mainText = t("exhibitors");
    } else if (location.pathname.startsWith('/exponents')) {
        mainText = t("exhibitors");
    } else if (location.pathname.startsWith('/events-asiaexpo')) {
        mainText = t("eventsAE");
    } else if (location.pathname.startsWith('/bookmarks')) {
        mainText = t("bookmarks");
    } else if (location.pathname.startsWith('/archive-events/congress-asiaexpo-2024/exposition')) {
        mainText = t("exposition");
    } else if (location.pathname.startsWith('/exposition')) {
        mainText = t("exposition");
    } else if (location.pathname.startsWith('/travel-plan')) {
        mainText = t("driveDirect");
    } else if (location.pathname.startsWith('/profile')) {
        if (location.pathname.startsWith('/profile/edit')) {
            mainText = t("editProfile");
        } else if (location.pathname.startsWith('/profile/company')) {
            mainText = t('companyInf');
        } else if (location.pathname.startsWith('/profile/exponents')) {
            mainText = t('myExhibitors');
        } else {
            mainText = t("profile");
        }
    } else if (location.pathname.startsWith('/scan')) {
        mainText = t('qrCode');
    } else if (location.pathname.startsWith('/faq')) {
        mainText = t("faq");
    } else if (location.pathname.startsWith('/support')) {
        mainText = t('techsup');
    } else if (location.pathname.startsWith('/asiameet')) {
        if (location.pathname.startsWith('/asiameet/form-meeting')) {
            mainText = t('meetka');
        } else {
            mainText = 'AsiaMeet';
        }
    } else if (location.pathname.startsWith('/notifications')) {
        mainText = t("notif");
    } else if (location.pathname.startsWith('/archive-events/congress-asiaexpo-2024/exponents')) {
        mainText = segmentTopbar;
    } else if (location.pathname.startsWith('/archive-events/congress-asiaexpo-2024/business-program')) {
        mainText = t("busProgram");
    } else if (location.pathname.startsWith('/business-program')) {
        mainText = t("busProgram");
    } else if (location.pathname.startsWith('/ticket')) {
        mainText = t("tiket");
    } else if (location.pathname.startsWith('/polic/')) {
        mainText = t("policyTitle");
    } else if (location.pathname.startsWith('/checkout-step-shipping')) {
        mainText = t('orderPlacement');
    } else if (location.pathname.startsWith('/checkout-step-payment')) {
        mainText = t("tiket");
    } else if (location.pathname.startsWith('/exponent-presentation')) {
        mainText = pdf.title;
    } else if (location.pathname.startsWith('/persons')) {
        mainText = t('persons');
    } else if (location.pathname.startsWith('/gras')) {
        if (location.pathname.startsWith('/gras/description-congress')) {
            mainText = t('descCongress');
        } else if (location.pathname.startsWith('/gras/business-program')) {
            mainText = t('busProgram');
        } else {
            mainText = t('main');
        }
    } else if (location.pathname.startsWith('/create-meeting')) {
        mainText = t('appointMeet');
    } else if (location.pathname.startsWith('/instruction')) {
        mainText = 'Инструкция';
    } else if (location.pathname.startsWith('/policy')) {
        mainText = t('policyAsia');
    }

    forums.map(function (forum) {
        if (location.pathname === `/archive-events/congress-asiaexpo-2024/business-program/event/${forum.id}`)
            mainText = `${languageString === "en" ? forum.name_en : forum.name}`
        if (location.pathname === `/archive-events/congress-asiaexpo-2023/business-program-archive/event/${forum.id}`)
            mainText = `${languageString === "en" ? forum.name_en : forum.name}`
        if (location.pathname === `/business-program/event/${forum.id}`)
            mainText = `${languageString === "en" ? forum.name_en : forum.name}`
        if (location.pathname === `/gras/business-program/${forum.id}`)
            mainText = `${languageString === "en" ? forum.name_en : forum.name}`
    })

    notifications.map(function (notif) {
        if (location.pathname === `/notifications/${notif.id}`)
            mainText = `${notif.subject}`
    })

    exponents.map(function (exponent) {
        if (location.pathname === `/archive-events/congress-asiaexpo-2024/exponents/exponents-card/${exponent.id}`)
            mainText = `${languageString === "en" ? exponent.name_en : exponent.name}`
        if (location.pathname === `/archive-events/congress-asiaexpo-2023/exponents/exponents-card/${exponent.id}`)
            mainText = `${languageString === "en" ? exponent.name_en : exponent.name}`
        if (location.pathname === `/exponents/exponents-card/${exponent.id}`)
            mainText = `${languageString === "en" ? exponent.name_en : exponent.name}`
        // if (location.pathname === `/gras/exponents/exponents-card/${exponent.id}`)
        //     mainText = `${languageString === "en" ? exponent.name_en : exponent.name}`
    })

    if (isArray(orders))
        orders.map(function (order){
            if (location.pathname === `/checkout-step-confirm/${order.order_key}`)
                mainText = t("tiket")
        })

    if (location.pathname === '/schedule')
        mainText = t("timetable")


    useEffect(() => {
        if (!location.pathname.startsWith('/exponents')) {
            setIsSearchOpen(false);
            setIsSearchOpenArchive(false);
            setFilterDropdownOpen(false);
            setFilterDropdownOpenArchive(false)
            dispatch(setFilterExpClose())
        }

        if (location.pathname.startsWith('/exponents/exponents-card')) {
            const exponentId = parseInt(location.pathname.split('/').pop());
            const exponent = exponents.find(c => c.id === exponentId);

            if (exponent) {
                setCurrentExponentName(languageString === "en" ? exponent.name_en : exponent.name);
                setIsSearchOpen(false);
                setIsSearchOpenArchive(false)
            }
        } else {
            setCurrentExponentName('');
        }
        if (!location.pathname.startsWith('/exponents') && !location.pathname.startsWith('/exponents/exponents-card')) {
            setIsSearchOpen(false);
            setIsSearchOpenArchive(false)
        }

        if (!location.pathname.startsWith('/asiameet')) {
            dispatch(setCloseFilter())
        }

        if (location.pathname.startsWith('/exponents/exponents-card')) {
            const exponentId = parseInt(location.pathname.split('/').pop());
            const exponent = exponents.find(c => c.id === exponentId);

            if (exponent) {
                setCurrentExponentName(languageString === "en" ? exponent.name_en : exponent.name);
                setIsSearchOpen(false);
                setIsSearchOpenArchive(false)
            }
        } else {
            setCurrentExponentName('');
        }


        setSearchState({
            search: '',
            context: searchContext,
        });
    }, [location.pathname, searchContext]);

    function handleSubmit() {
        // const matchedCompanies = exponents.filter(c =>
        //     c.name.toLowerCase().includes(searchState.search.toLowerCase())
        // );
        //
        // if (matchedCompanies.length > 0) {
        //     navigate('/exponents/', { state: { results: matchedCompanies } });
        // } else {
        //     navigate('/exponents/', { state: { results: [] } });
        //     console.log('');
        // }
        //
        // dispatch(closeSearch());
        // if (mixpanel) {
        //     mixpanel.track('Search Confirm', { ...userLocation, ...userData, ...searchState });
        // }
        dispatch(clearSearch())
        dispatch(closeSearch());
       // dispatch(setSearchContext(searchState.context));
       // navigate(`/search/${searchState.search}`, {state: {doQuery: true}});
    }

    function handleChangeSearch(e) {
       // console.log('handleChangeSearch' ,e);

        setSearchState({ search: e.target.value });
        if (e.target.value.length >= 3) {
            dispatch(setSearch(e.target.value));
        } else if (e.target.value.length < 3) {
            dispatch(clearSearch());
        }
    }

    function handleOpenSearch() {
        setIsSearchOpen(!isSearchOpen);  // Переключение состояния
        setFilterDropdownOpen(false);
        setFilterDropdownOpenArchive(false);
        setIsSearchOpenArchive(!isSearchOpenArchive)
        dispatch(closeMenu());
        dispatch(clearSegmentFilter())
        dispatch(clearCountryFilter())
    }



    function handleOpenAuth() {
        dispatch(openAuth());
        if (mixpanel) {
            mixpanel.track('Auth Open Form', { ...userLocation, ...userData });
        }
    }

    function handleSelectContext(e, data) {
        setSearchState({ ...searchState, context: data.value });
    }

    const handleFilterOpen = () => {
        if (!isModalOpen) {
            dispatch(setFilterExpOpen())
        } else {
            dispatch(setFilterExpClose())
        }
        setFilterDropdownOpen(!isFilterDropdownOpen)
        setIsSearchOpen(false)
        setIsSearchOpenArchive(false)
        //setFilterDropdownOpenArchive(!isFilterDropdownOpenArchive)
        if (location.pathname === "/exponents" && filterExponents.country.length > 0 || filterExponents.segment.length > 0) {
            setFilterDropdownOpen(true);
        }
        if (location.pathname === "/exponents" && filterExponents.country.length > 0 || filterExponents.segment.length > 0) {
            setFilterDropdownOpenArchive(true);
        }
    }

    const handleFilterAsiameetOpen = () => {

        switch (isMeetsFilterOpen) {
            case false:
                return dispatch(setOpenFilter())
            case true:
                return dispatch(setCloseFilter())
        }

        setIsSearchOpen(false)
        //setFilterDropdownOpenArchive(!isFilterDropdownOpenArchive)

    }

    const handleFilterOpenArchive = () => {
        setFilterDropdownOpenArchive(!isFilterDropdownOpenArchive)
        setIsSearchOpen(false)
        setIsSearchOpenArchive(false)
      //  setFilterDropdownOpenArchive(!isFilterDropdownOpenArchive)
        if (location.pathname === "/archive-events/congress-asiaexpo-2024/exponents" && filterExponents.country.length > 0 || filterExponents.segment.length > 0) {
            setFilterDropdownOpen(true);
        }
        if (location.pathname === "/archive-events/congress-asiaexpo-2023/exponents" && filterExponents.country.length > 0 || filterExponents.segment.length > 0) {
            setFilterDropdownOpenArchive(true);
        }
    }

    const GlobalFilter = ({ className, alt, children }) => (
        <button className={className} alt={alt}>
            {children}
        </button>
    );

    // console.log(isModalOpen)

    const filterDropdown = () => (
        <div className="filter-dropdown">
            <div className='close-icon-exp-filters' onClick={() => dispatch(setFilterExpClose())}>
                {typeExhibition === 'asia' ?
                    <CloseIconAsia/> : <CloseIconGras/>}
            </div>
            <div className='filter-country'>
                <span>{t("country")}</span>
                <ModalCountry/>
            </div>
            <div className='filter-segment'>
                <span>{t("segment")}</span>
                <ModalSegment/>
            </div>

            <Button
                className='clear-filters-btn'
                onClick={() => {
                    dispatch(setCountryFilter(''))
                    dispatch(setSegmentFilter(''))
            }}>Сбросить</Button>
        </div>
    );

    // exponents.map(function (exponent) {
    //     if (location.pathname === `/exponents/exponents-card/${exponent.id}`)
    //         setIsSearchOpen(false)
    //     if (location.pathname === `/archive-events/congress-asiaexpo-2023/exponents/exponents-card/${exponent.id}`)
    //         setIsSearchOpen(false)
    // })



    const searchForm = () => (
        <>
            <Form onSubmit={handleSubmit} className="search-form-s">
                <input
                    type='search'
                    placeholder={t("enterRequest")}
                    name="search"
                    className="search-input"
                    value={searchState.search}
                     onChange={handleChangeSearch}
                     autoFocus={true}
                    autoComplete="off"

                 >
                     {/*<input className="search-field"/>*/}
                     {/*<Button className="search-button" onClick={() => closeSearchInput()}  type="submit" icon="search"/>*/}
                 </input>
             </Form>
         </>
     );




    const arrayCountries = countries && countries.countries ? Object.values(countries.countries).map(country => ({
        'key': country.iso.toLowerCase(),
        'value': country.iso.toLowerCase(),
        'flag': country.iso.toLowerCase(),
        'text': languageString === "en" ? country.country_en : country.country_ru,
        'states': country.states
    })) : [];

    const arraySegments = segments ? Object.values(segments).map(segment => ({
        'value': segment.term_id,
        'text': languageString === "en" ? segment.name_en : segment.name,
    })) : [];

    const [selectedSegment, setSelectedSegment] = useState('');

    const handleSegmentSelect = (e, { value }) => {
        dispatch(setSegmentFilter(value));
    };

    const handleCountrySelect = (e, { value }) => {
        dispatch(setCountryFilter(value));
    };


    const ModalCountry = () => {
        return (
            <>
                 <Form>
                        <FormField className='filter-field'>
                            <div className='filter-container'>
                                <Dropdown
                                    search
                                    name='country'
                                    selection
                                    className={`filter-input ${typeExhibition}`}
                                    placeholder={t("country")}
                                    multiple
                                    clearable
                                    noResultsMessage={t("notFound")}
                                    options={arrayCountries}
                                    value={filterExponents.country}
                                    onChange={handleCountrySelect}
                                />
                            </div>
                        </FormField>
                    </Form>
              </>
        )
    }

    const ModalSegment = () => {
        return (
            <>
                <Form>
                    <FormField className='filter-field'>
                        <div className='filter-container'>
                            <Dropdown
                                search
                                name='segment'
                                className={`filter-input ${typeExhibition}`}
                                placeholder={t("segment")}
                                multiple
                                selection
                                clearable
                                noResultsMessage={t("notFound")}
                                options={arraySegments}
                                value={filterExponents.segment}
                                onChange={handleSegmentSelect}
                            />
                        </div>
                    </FormField>
                </Form>
            </>
        )
    }


    return (
        <>
            <Menu fluid secondary fixed="top" id="nav-top-bar" className={`nav-top-bar ${typeExhibition}`} color="blue" icon="labeled" inverted>
                {!isMainView && !isProfileView && !isBookmarksView && !isAsiameetView && !isNotificationsView && !isScheduleView
                    ? <BackIcon className="shop-icon back-icon" onClick={() => isFormChanged ? dispatch(setPopupOpen(-1)) : isTicketView ? navigate("/") : navigate(-1)} />
                    : ''
                }


                {isSearchOpen && (
                    <div>
                        {searchForm()}
                    </div>
                )}

                {!isSearchOpen && (
                    <Menu.Item
                        style={{ maxWidth: '752px'}}
                        className={"top-bar-menu-title" + (isMainView ? " first-left" : " second-left")}
                    >
                        <span className='header-title-text'>{currentExponentName || mainText}</span>
                    </Menu.Item>
                )}


                {isExponentsView && (
                    <>
                        <Menu.Item className="shop-icon-item first-right" onClick={handleOpenSearch}>
                            <SearchIcon className="shop-icon"/>
                        </Menu.Item>
                        <Menu.Item className="shop-icon-item second-right" onClick={() => handleFilterOpen()}>
                            <FilterIcon className="shop-icon" />
                        </Menu.Item>
                    </>
                )}

                {/*{isAsiaMeetView && (*/}
                {/*    <>*/}
                {/*        /!*<Menu.Item className="shop-icon-item first-right" onClick={handleOpenSearch}>*!/*/}
                {/*        /!*    <SearchIcon className="shop-icon"/>*!/*/}
                {/*        /!*</Menu.Item>*!/*/}
                {/*        <Menu.Item className="shop-icon-item third-right" onClick={() => handleFilterAsiameetOpen()}>*/}
                {/*            <FilterIcon className="shop-icon" />*/}
                {/*        </Menu.Item>*/}
                {/*    </>*/}
                {/*)}*/}

                {isExponentsArchiveView && (
                    <>
                        <Menu.Item className="shop-icon-item first-right" onClick={handleOpenSearch}>
                            <SearchIcon className="shop-icon"/>
                        </Menu.Item>
                        <Menu.Item className="shop-icon-item second-right" onClick={() => handleFilterOpenArchive()}>
                            <FilterIcon className="shop-icon" />
                        </Menu.Item>
                    </>


                )}


                {(location.pathname === '/' || location.pathname === '/profile' || location.pathname === '/support' || location.pathname === '/faq' || location.pathname === '/bookmarks' || location.pathname === '/asiameet' || location.pathname === '/notifications' || location.pathname === "/schedule") && (
                    <>

                        <Menu.Item className="shop-icon-item second-right" onClick={() => navigate("/notifications")}>
                            <img className="shop-icon" src={BellIcon} alt="" />
                        </Menu.Item>
                        <Menu.Item className="shop-icon-item first-right">
                            <LanguageModal
                                triggerButton={(
                                    <img className="shop-icon" src={LanguageIcon} alt=""/>
                                )}
                                onLanguageChange={handleLanguageChange}
                                currentLanguage={languageString}
                            />
                        </Menu.Item>
                    </>

                )}
                {/*{location.pathname !== '/gras' ? <Menu.Item className="shop-icon-item" onClick={() => navigate("/gras")}>*/}
                {/*    Грас*/}
                {/*</Menu.Item> : ''}*/}
            </Menu>
            {isExponentsView && isFilterDropdownOpen && isModalOpen &&  filterDropdown()}
            {isExponentsArchiveView && isFilterDropdownOpenArchive && isModalOpen && filterDropdown()}

        </>

    );
}
